import { render } from "./NameComponent.vue?vue&type=template&id=4fcdb379&scoped=true"
import script from "./NameComponent.vue?vue&type=script&lang=js"
export * from "./NameComponent.vue?vue&type=script&lang=js"

import "./NameComponent.vue?vue&type=style&index=0&id=4fcdb379&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcdb379"]])

export default __exports__